import DebtorChip from "@/components/shared/debtor-chip";
import { create_error_code_toast } from "@/components/shared/error-code-toast";
import { clientFetch, url } from "@/components/shared/fetch-client/fetch_client";
import TableBase, { TableIdEnum } from "@/components/shared/table/table-base";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BlockIcon from "@mui/icons-material/Block";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "next/link";
import { useState } from "react";
import { useTranslation } from "react-i18next";
export default function DebtorTable({ url_params_enabled = true }) {
	// Hooks
	const { t } = useTranslation();
	const [count, setCount] = useState(0);
	const [rows, setRows] = useState([]);

	const onChangeHandler = async (params, setLoading) => {
		// Make fetch call
		try {
			const response = await clientFetch(url`/api/back-office/debtor`, {
				params: { ...params },
			}).get();

			if (!response.ok) {
				return null;
			}

			setCount(response.body.count);
			setRows(response.body.data);
		} catch (error) {
			create_error_code_toast(t, error);
		} finally {
			setLoading(false);
		}
	};

	const additionalFilters = [
		{
			key: "membership_type",
			label: t("back_office.customers.debtors.membership_type.label"),
			option_list: [
				{
					label: t("back_office.customers.debtors.membership_type.private"),
					value: "private",
				},
				{
					label: t("back_office.customers.debtors.membership_type.business"),
					value: "business",
				},
			],
			type: "select",
		},
	];

	return (
		<Box sx={{ my: 3 }}>
			<TableBase
				enable_search
				enable_reset_button
				sort_default="asc"
				order_by_default="debtor_code"
				url_params_enabled={url_params_enabled}
				on_change={onChangeHandler}
				total_count={count}
				table_id={TableIdEnum.DEBTOR_TABLE_BACK_OFFICE_INDEX}
				additional_filters={additionalFilters}
				column_list={[
					{
						key: "debtor_code",
						label: t("back_office.customers.debtors.table.debtor_code"),
						width: "210px",
					},
					{
						key: "company_name",
						label: t("back_office.customers.debtors.table.company"),
					},
					{
						key: "membership_type",
						label: t("back_office.customers.debtors.table.type"),
					},
					{
						key: "given_name",
						label: t("back_office.customers.debtors.table.given_name"),
					},
					{
						key: "middle_name",
						label: t("back_office.customers.debtors.table.middle_name"),
					},
					{
						key: "family_name",
						label: t("back_office.customers.debtors.table.family_name"),
					},
					{
						key: "row_actions",
						label: "",
						sortable: false,
					},
				]}
				row_list={rows.map((row) => ({
					cell_list: [
						// DEBTOR ID
						{
							key: "debtor_code",
							value: (
								<Box display="flex" alignItems="center">
									<DebtorChip
										debtor_id={row.id}
										debtor_code={row?.debtor_code || t("validation.debtor_code_unverified")}
										is_back_office
									/>
									{row?.blocked && <BlockIcon sx={{ height: 18, ml: 1 }} />}
								</Box>
							),
						},

						// COMPANY
						{
							key: "company_name",
							value: row?.company_name || "-",
						},

						// Membership type
						{
							key: "membership_type",
							value: row?.membership_type,
						},
						// Given name
						{
							key: "given_name",
							value: row?.given_name,
						},
						// Middle name
						{
							key: "middle_name",
							value: row?.middle_name || "-",
						},
						// Family name
						{
							key: "family_name",
							value: row?.family_name,
						},

						{
							key: "row_actions",
							value: (
								<Box sx={{ display: "flex", justifyContent: "flex-end" }}>
									<Link href={`/back-office/customers/debtor/${row.id}`} passHref>
										<Button
											variant="outlined"
											endIcon={<ArrowForwardIcon />}
											sx={{ ml: 2 }}
											size="small"
										>
											{t("back_office.customers.debtors.table.details")}
										</Button>
									</Link>
								</Box>
							),
						},
					],
				}))}
			/>
		</Box>
	);
}
